import graphqlClient from "@/GQLClient";
import type { InstitutionsEmployeeOnly, PeopleGroup } from "@/graphql";
import { GetEmployeesAndResidentsDocument } from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const getEmployeesAndResidents = async (): Promise<PeopleGroup> => {
  const response = await graphqlClient.query({
    query: GetEmployeesAndResidentsDocument,
    variables: {
      filter: {},
    },
  });

  if (response.error) {
    throw new SentryGraphQLError();
  }

  return {
    employees:
      (response.data.institutions?.getMyInstitution.employees?.edges || [])
        .map((edge) => edge.node)
        .filter(
          (node): node is InstitutionsEmployeeOnly =>
            node.__typename === "Employee",
        ) || [],
    residents: response.data.institutions?.getMyInstitution?.residents || [],
  };
};

export default {
  getEmployeesAndResidents,
};
